import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Drawer from '@material-ui/core/Drawer';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import ReactJson from 'react-json-view'
import Accordion from '@material-ui/core/Accordion';

import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import fromUnixTime from 'date-fns/fromUnixTime'
import { format, compareAsc } from 'date-fns'


import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  drawer:  { 
    minWidth: 600, 
    padding: 10, 
    maxWidth: 650, 
    backgroundColor: '#efefef'
  }
});

function Capitalize(str) { 
  if (typeof(str) == 'string') { 
    return str.charAt(0).toUpperCase() + str.slice(1);
  } else { 
    return str
  }
}

function getValFromObj (input, param) { 
  if (typeof param == 'string') { 
    try { 
      let allParams = param.split('.')
      let final = {...input}
      allParams.forEach( x => { 
        final = final[x]
      })
      return final
    } catch (e) { 
      console.log('Error getValFromObj()')
    }

  } else { 
    console.log('error')
  }
}

export default function BasicTable(props) {
  const [isOpen, setOpen] = useState(false)
  const [currentData, setData] = useState({})
  const classes = useStyles();
  
  const selectRow = (data) => { 
    console.log("Selected Row", data)
    setData(data)
    setOpen(true)
  }

  const closeRow = () => { 
    // setData({})
    setOpen(false)
  }

  function getChipColor(str){ 
    if (str == 'success') { 
      return 'primary'
    } else if (str == 'error') { 
      return 'secondary'
    } else { 
      return 'default'
    }
  }
  // props.data.sort((a, b) => (a.timestamp < b.timestamp) ? 1 : -1)

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            { props.config.map( (x, i) => { 
              return(
                <TableCell align={i == 0 ? "left" : "center"} key={x.id}>{x.title}</TableCell>
              )
            }) 
            }
 
          </TableRow>
        </TableHead>
        <TableBody>
          
          { props.data.map( x => { 
            let date = new Date(x['timestamp'] * 1000) 
            let day = date.getMonth() + '-' + date.getDate() + '-' + date.getFullYear()
            var result = fromUnixTime(x['timestamp'])
            // let time = date.getHours() + ':' + date.getMinutes() 
            let time = format(result, 'p')
            return( 
            <TableRow key={x.id} hover onClick={()=>selectRow(x)}>
                { props.config.map( (y, i) => { 
                 
                  return(
                   <TableCell align={i == 0 ? "left" : "center"} key={y.id} >
                    { y.id == 'date' || y.id == 'time' ? 
                      <React.Fragment>
                        { y.id == 'date' ? 
                          day
                          : time
                        }
                      </React.Fragment> 
                     : 
                     <React.Fragment>
                       { y.id == 'status' ? 
                          <Chip label={x[y.id]} color={getChipColor(x[y.id])} style={{width: 100}}/>
                        :
                          getValFromObj(x, y.id)
                       }
                     </React.Fragment>
                    }
                   </TableCell>
                  )
                }) 
              }
      
              {/* <TableCell align="right"> <Chip label="Success" /> </TableCell> */} 
            </TableRow>
            )
          }) 
          }
       
        </TableBody>
      </Table>
       <Drawer anchor={'right'} open={isOpen} onClose={closeRow} >
         <div className={classes.drawer}>
          <h1>{currentData.function}</h1>

          {/* <Accordion>
            <AccordionSummary
              // expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <h2>Values</h2>
            </AccordionSummary>
            <AccordionDetails>
              
              <ValuesTable
               data={currentData?.data?.values}
              />
            </AccordionDetails>
          </Accordion> */}

          <Card style={{marginTop: 20}} raised={true} elevation={1}>
            <CardHeader title="Values"/>
            <CardContent>

              <ValuesTable
               data={currentData?.data?.values}
              />
            </CardContent>
          </Card>
          
          <Card variant="outlined" style={{marginTop: 20}}>
            <CardHeader title="Logs"/>
            <CardContent>
              <LogsTable
               data={currentData?.data?.logs}
              />
            </CardContent>
          </Card>

          <Card variant="outlined" elevation={20} style={{marginTop: 20}}>
            <CardHeader title="Raw"/>
            <CardContent style={{backgroundColor: '#0B1C2C'}}>
            <ReactJson theme='harmonic' src={currentData} collapsed={1}/>
            </CardContent>
          </Card>

         </div>
        </Drawer>
    </TableContainer>
  );
}

function ValuesTable(props) { 
  return(
    <TableContainer component={Paper} >
    <Table  aria-label="values table">
    <TableHead>
          <TableRow>
            <TableCell>Key</TableCell>
            <TableCell>Value</TableCell>
          </TableRow>
        </TableHead>
      <TableBody>
        {Object.entries(props.data).map(([key, value]) => (
          <TableRow key={key} onClick={()=>console.log(typeof(value), JSON.stringify(value), JSON.parse(value))}>
            <TableCell scope="row" >
              {key}
            </TableCell>
            <TableCell scope="row" >
              { typeof(value) == 'string' || typeof(value) == 'number' || typeof(value) == 'boolean' ? 
                String(value)
                : 
                <ReactJson src={value} collapsed={0} />
              }
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
  )
}

function LogsTable(props) { 
  return(
    <TableContainer component={Paper} >
    <Table size="small" aria-label="function logs">
      <TableBody>
        {props.data.map((row) => (
          <TableRow key={row}>
            <TableCell scope="row" style={{fontFamily: 'monospace'}}>
              {row}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
  )
}

LogsTable.defaultProps = { 
  data: ['Some logs', 'printed data']
}

BasicTable.defaultProps = { 
  data: []
}

